// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2bCAL","log":"ModalInventoryLogs_log__3-uX6","date":"ModalInventoryLogs_date__2ufik","userName":"ModalInventoryLogs_userName__3DYOp"};